import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Button, Modal, Tabs } from "antd";
import HighlightLinksComponents from "./HighlightLinksComponents";
import '../../../../../styles/StayUptoDateCSS/StayUpToDateControls.css'
import { addComponent } from "../../../../../Utils/SupabaseServices/StayUpToDateDatabase";
import { ModalBackButton } from "../../../../../components/EditModalComponents.tsx/ModalBackButton";

const HighlightComponents = (props: any) => {
  const {
    username,
    user_id,
    isHighlightModalOpen,
    setIsHighlightModalOpen,
    setIsModalOpen,
    refetch,
    from
  } = props;
  const [activeKey, setActiveKey] = useState("content");
  const [dataCompleted, setDataCompleted] = useState(false);
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [cta, setCTA] = useState("");
  const [type, setType] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [image, setImage] = useState("");
  const [view, setView] = useState("left")
  const [defaultFileList, setDefaultFileList] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleOk = async () => {
    // Validate inputs before proceeding
    if (!name.trim() && !cta.trim()) {
      setErrorMsg("Either highlight title or button text is required.");
      return;
    }

    if (name && name.length > 150) {
      setErrorMsg("Highlight title cannot exceed 150 characters.");
      return;
    }

    if (!link.trim()) {
      setErrorMsg("Button link is required.");
      return;
    }

    if (cta && cta.length > 20) {
      setErrorMsg("Button text cannot exceed 20 characters.");
      return;
    }

    setConfirmLoading(true);
    const res = await addComponent(
      name,
      [image || "", link, type, view].toString(),
      username,
      user_id,
      "false",
      cta,
      "",
      name,
      "highlight",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      from
    );
    if (res === "true") {
      setErrorMsg("");
      setIsHighlightModalOpen(false);
      setIsModalOpen(false);
      refetch();
      setActiveKey("content");
      setName("");
      setLink("");
      setImage("");
      setType("");
      setView("left")
      setCTA("")
      setDefaultFileList([]);
      setDataCompleted(false);
      setConfirmLoading(false);

    } else {
      setErrorMsg("Component with the same name already exists.");
      setConfirmLoading(false);

    }

  };

  const handleCancel = () => {
    setIsHighlightModalOpen(false);
    setIsModalOpen(false);
    setName("");
    setLink("");
    setImage("");
    setType("");
    setView("left")
    setCTA("")
    setErrorMsg("");
    setActiveKey("content");

    setDefaultFileList([]);
    setDataCompleted(false);
  };
  const handlePrevious = () => {
    setIsModalOpen(true);
    setIsHighlightModalOpen(false);
    setName("");
    setLink("");
    setImage("");
    setType("");
    setErrorMsg("");
    setView("left")
    setCTA("")
    setActiveKey("content");

    setDefaultFileList([]);

    setDataCompleted(false);
  };
  const navTabs = [
    {
      key: "content",
      label: "Content",
      disabled: false,
    },
    {
      key: "shoplink",
      label: "Shop Link",
      disabled: false,
    },
  ];

  async function handleData(
    image: any,
    name: any,
    link: any,
    kind: any,
    cta: any
  ) {
    if (name) setName(name);
    if (link) setLink(link);
    if (image) setImage(image);
    if (kind) setType(kind);
    if (cta) setCTA(cta);
    
    // Set dataCompleted if we have either name or cta (as per our new requirement)
    setDataCompleted(!!(name || cta));
  }

  return (
    <>
      <Modal
        // title={
        //   <div className="modal-title">
        //     <button
        //       onClick={handlePrevious}
        //       className="newbutton"
        //     >
        //       <FaArrowLeft />
        //     </button>
        //   </div>
        // }
        open={isHighlightModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Add"
        confirmLoading={confirmLoading}
        // okButtonProps={{ 
        //   disabled: isUploading || !dataCompleted || 
        //   (cta && cta.length > 15) || 
        //   name?.length > 150 
        // }}
        data-testid="create-highlights"
        width={600}
        centered
        className="add-to-page-modal"
        closeIcon={<span className="modal-close-icon">×</span>}
      >
        <ModalBackButton handlePrevious={handlePrevious}  />
        <h5 className="title mb-15">Create a Highlight</h5>

        <HighlightLinksComponents
          username={username}
          user_id={user_id}
          handleData={handleData}
          defaultName={name}
          link={link}
          image={image}
          errorMsg={errorMsg}
          defaultFileList={defaultFileList}
          setErrorMsg={setErrorMsg}
          cta={cta}
          setCTA={setCTA}
          setName={setName}
          view={view}
          setView={setView}
          setIsUploading={setIsUploading}
          isUploading={isUploading}
        />

      </Modal>
    </>
  );
};


export default HighlightComponents;
